import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  List,
  ListItem,
  ListItemText,
  LinearProgress
} from '@mui/material';

const AIInsightsSidebar = ({ insights }) => {
  if (!insights) {
    return null;
  }

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'HIGH':
        return 'error';
      case 'MEDIUM':
        return 'warning';
      case 'LOW':
        return 'info';
      default:
        return 'default';
    }
  };



  return (
    <Box sx={{ position: 'sticky', top: 20 }}>
      <Card sx={{ mb: 2 }}>
        <Box sx={{ px: 2, py: 1.5, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
          <Typography variant="subtitle2">
            AI Insights
          </Typography>
        </Box>
        <CardContent>
          {/* Top Risk Indicators */}
          {insights.topRiskIndicators && insights.topRiskIndicators.length > 0 && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="overline" sx={{ color: 'text.secondary', mb: 1, display: 'block' }}>
                TOP RISK INDICATORS
              </Typography>
              <List dense disablePadding>
                {insights.topRiskIndicators.map((indicator, idx) => (
                  <ListItem key={idx} disableGutters sx={{ borderBottom: 1, borderColor: 'divider', py: 0.5 }}>
                    <ListItemText
                      primary={indicator}
                      primaryTypographyProps={{ variant: 'caption' }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}

          {/* Recommended Actions */}
          {insights.recommendedActions && (
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                <Typography variant="overline" sx={{ color: 'text.secondary' }}>
                  RECOMMENDED ACTIONS
                </Typography>
                <Chip
                  label={insights.recommendedActions.priority}
                  color={getPriorityColor(insights.recommendedActions.priority)}
                  size="small"
                  sx={{ fontWeight: 600 }}
                />
              </Box>

              {insights.recommendedActions.actions && insights.recommendedActions.actions.length > 0 && (
                <List dense disablePadding>
                  {insights.recommendedActions.actions.map((action, idx) => (
                    <ListItem
                      key={idx}
                      disableGutters
                      sx={{
                        borderBottom: idx < insights.recommendedActions.actions.length - 1 ? 1 : 0,
                        borderColor: 'divider',
                        py: 0.5
                      }}
                    >
                      <ListItemText
                        primary={
                          <Typography variant="caption">
                            <Typography component="span" variant="caption" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                              {idx + 1}.
                            </Typography>{' '}
                            {action}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          )}
        </CardContent>
      </Card>

      {/* Quick Stats */}
      <Card>
        <Box sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
          <Typography variant="subtitle2">
            Quick Stats
          </Typography>
        </Box>
        <CardContent>
          <Box sx={{ mb: 2 }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
              Analysis Coverage
            </Typography>
            <LinearProgress
              variant="determinate"
              value={100}
              color="success"
              sx={{ height: 20, borderRadius: 1 }}
            />
            <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block', textAlign: 'center', mt: 0.5 }}>
              Complete
            </Typography>
          </Box>

          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              Powered by Claude AI
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AIInsightsSidebar;
